import type { JSX } from 'solid-js';
import { splitProps } from 'solid-js';
import { classNames } from '../lib/classes';

type Props = JSX.InputHTMLAttributes<HTMLInputElement>;

export function Input(props: Props) {
  const [local, rest] = splitProps(props, ['class']);
  return (
    <input
      class={classNames(
        'w-full rounded-md border border-border bg-card px-3 py-2 text-sm text-fg placeholder:text-muted',
        'focus:outline-2 focus:outline-offset-0 focus:outline-tea-500',
        'disabled:opacity-50',
        local.class,
      )}
      {...rest}
    />
  );
}
